export const API_URL = 'https://api.setsender.com/api'
